<script>
    import Vue from 'vue';
    import VueGtag from 'vue-gtag';

    export default {
        name: 'GoogleAnalyticsTracker',
        props: {
            additionnalGTM: {
                type: String,
                required: false
            }
        },
        data: () => {
            return {
                globalGTM: 'GTM-WLGMNM9',
                gtmConfig: {}
            }
        },
        render() {
            this.gtmConfig['config'] = { 'id': this.globalGTM};
            if (this.$props.additionnalGTM)
                this.gtmConfig['includes'] = [
                    { 'id': this.$props.additionnalGTM }
                ];
            Vue.use(VueGtag, this.gtmConfig);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/components/GoogleAnalyticsTracker.vue